import { useEffect, useRef, useState } from "react";
import { isImageWallpaperRef } from "./galleryTheme";
import { extractGalleryImagePalette } from "./imagePalette";

// Live "From your image" swatch palette for the Accent/Background sections.
// Recomputes whenever the wallpaper image URL changes; [] (row hidden by the
// caller) for every non-image wallpaper and on any extraction failure.
export const useImagePalette = (wallpaper) => {
  const [palette, setPalette] = useState([]);
  const url = isImageWallpaperRef(wallpaper) ? wallpaper.url : null;
  // Guards against a slow, now-stale extraction landing after a newer
  // wallpaper change already started a fresh request.
  const requestId = useRef(0);

  useEffect(() => {
    if (!url) {
      setPalette([]);
      return;
    }
    const id = ++requestId.current;
    extractGalleryImagePalette(url).then((hexes) => {
      if (requestId.current === id) setPalette(hexes);
    });
  }, [url]);

  return { palette };
};
